<template lang="pug">
div
  b-form-group(
    :invalid-feedback="invalidFeedback"
  )
    .custom-form-group
      .material-icons.custom-icon-input {{ icon }}
      .custom-form-input
        div
          label.custom-form-label {{ label }}
            span(v-if="required" style="color: red") *
        slot
</template>

<script>
export default {
	props: {
		icon: {
			type: String,
			default: ''
		},
		label: {
			type: String,
			default: ''
		},
		invalidFeedback: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped>
.custom-form-group {
  display: flex;
  width: 100%;
  gap: 5px;
}

.custom-form-input {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.custom-icon-input{
  color: var(--secondary);
  font-size: 30px;
  margin-top: 22px;
  margin-right: 4px;
}

.custom-form-label {
  color: var(--light-primary);
  margin-bottom: 0.125rem;
  padding: 0;
  font-weight: bold;
  font-size: 13px;
}

</style>
